import { render, staticRenderFns } from "./SenderIdCellRendererActions.vue?vue&type=template&id=56d535b0&"
import script from "./SenderIdCellRendererActions.vue?vue&type=script&lang=js&"
export * from "./SenderIdCellRendererActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports